interface ClassRecordData {
    class_code: string;
    class_name: string;
    class_description: string | null;
    school_name: string;
    timezone: string;
}

type ClassType = 'class' | 'template';

export enum ClassStatus {
    Published = 'published',
    Draft = 'draft'
}

interface ClassRecord {
    class_code: string;
    class_description: string | null;
    class_name: string;
    class_number: string;
    class_options: {[key: string]: string};
    class_uuid: string;
    courseid: string;
    data: ClassRecordData;
    date_created: Date;
    meeting_id: string;
    random_value: number;
    school_name: string;
    settings_data: any;
    sid: number;
    status: ClassStatus;
    type: ClassType;
}

export interface FeatureUsage {
    user_count: number;
    private_chat_count: number;
    public_chat_count: number;
    breakout_chat_count: number;
    tab_type_all_files: number;
    tab_type_assessment: number;
    tab_type_assignment: number;
    tab_type_browse_the_web: number;
    tab_type_content_management: number;
    tab_type_file: number;
    tab_type_googledoc: number;
    tab_type_open_syllabus: number;
    tab_type_play_video: number;
    tab_type_poll: number;
    tab_type_survey: number;
    tab_type_syllabus: number;
    tab_type_whiteboard: number;
    talk_time_seconds: number;
    focus_time_seconds: number;
    focus_count: number;
    hand_raised_time: number;
    hand_raised_count: number;
    feedback_time_seconds: number;
    feedback_count: number;
    sum_student_max_stars: number;
    privacy_mode_off: number;
    privacy_mode_on: number;
    privacy_mode_optional: number;
    note_count: number;
    screenshot_count: number;
    transcript_count: number;
    proctor_mode_false: number;
    proctor_mode_true: number;
    record_set_false_count: number;
    recording_set_true_count: number;
}

export interface DashboardClassRecord {
    class_code: string;
    class_description: string | null;
    class_name: string;
    class_number: string;
    class_options: {[key: string]: string};
    class_uuid: string;
    courseid: string;
    data: ClassRecordData;
    date_created: Date;
    meeting_id: string;
    random_value: number;
    school_name: string;
    settings_data: any;
    sid: number;
    status: ClassStatus;
    type: ClassType;
    name?: string;
    feature_usage?: FeatureUsage;
    class_sessions?: DashboardClassSessionRecord[];
    students?: any[];
}

export interface DashboardClassSessionRecord {
    name: string;
    sid: number;
    class_id: string;
    start_time: number;
    end_tim: number;
    weekday_str: string;
    date_str: string;
    start_time_str: string;
    end_time_str: string;
    status: string;
    timezone: string;
    class_session_uuid: string;
    class_uuid: string;
    feature_usage?: FeatureUsage;
    events?: any[];
    class?: DashboardClassRecord;
    students?: any[];
    usage_events?: any;
}

export interface DashboardStudentRecord {
    user_name: string;
    role: string;
    usageEvents?: any[];
}

export interface DashboardTeacherRecord {
    user_name: string;
    role: string;
    usageEvents?: any[];
}

export interface TemplateRecord extends ClassRecord {}

export enum ActionType {
    Publish = 'Publish',
    Unpublish = 'Unpublish'
}
